import type {
  CollectionSustainabilityConfig,
  SustainabilityComponentInput,
} from "@repo/shared/types";
import { usePublicFlowDefinition } from "@/lib/hooks/use-public-flow/use-flow-instance";
import {
  usePublicSustainabilityValue,
  useSavePublicSustainability,
} from "@/lib/hooks/use-public-flow/use-sustainability";
import { SustainabilityWidget } from "@/pages/clients/detail/flows/instance/sustainability-widget";

type SustainabilityRendererProps = {
  component: { config?: string };
  isCompleted: boolean;
  language: string;
  hasValidationError?: boolean;
  /** QL-188 — group answering note; null for non-group clients. */
  groupNote?: string | null;
};

export function SustainabilityRenderer({
  component,
  isCompleted,
  language,
  hasValidationError,
  groupNote,
}: SustainabilityRendererProps) {
  const { definition } = usePublicFlowDefinition();
  const { inputData, isLoading: valueLoading } = usePublicSustainabilityValue();
  const save = useSavePublicSustainability();

  let config: { style?: "none" | "border" | "box"; title?: string; description?: string } = {};
  try {
    config = component.config ? JSON.parse(component.config) : {};
  } catch {
    // Invalid config, use defaults
  }

  const sustainabilityConfig =
    ((definition as any)?.portfolioCollection
      ?.sustainabilityConfig as CollectionSustainabilityConfig | null) ?? null;

  const handleChange = (input: SustainabilityComponentInput) => {
    save.mutate(input);
  };

  if (valueLoading) return null;

  return (
    <SustainabilityWidget
      sustainabilityConfig={sustainabilityConfig}
      inputData={inputData}
      onChange={handleChange}
      disabled={isCompleted}
      style={config.style}
      title={config.title}
      description={config.description}
      language={language}
      hasValidationError={hasValidationError}
      groupNote={groupNote}
    />
  );
}
